import wrapWith from './private/wrapWith.tsx';

export default wrapWith;
